import React from "react";

const ImportButton = ({ onClick, text }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 border border-white text-white px-4 py-2 rounded-lg hover:bg-white hover:text-black transition duration-300 whitespace-nowrap">
      <DownloadIcon />
      <span>{text}</span>
    </button>
  );
};

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    className="w-5 h-5">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4v12m0 0l-4-4m4 4l4-4M4 16h16"
    />
  </svg>
);

export default ImportButton;
